<template>
    <v-container class="mb-12 mb-lg-0">
        <v-row justify="center">
            <v-col md="12">
                <v-list v-if="loading" two-line>
                    <template v-for="index in 4">
                        <v-skeleton-loader :key="'loader-' + index" type="list-item-avatar-two-line"/>
                        <v-divider v-if="index < 4" :key="'loader-divider-' + index"/>
                    </template>
                </v-list>
                <v-alert v-else-if="notificationItems.length === 0" text color="primary" icon="mdi-bell-outline">
                    No tienes notificaciones por ahora.
                </v-alert>
                <v-list v-else two-line>
                    <template v-for="(item, index) in notificationItems">
                        <v-list-item
                            :key="'N' + index"
                            :class="item.status === 0 ? 'v-list-item--active' : ''"
                            active-class="primary--text"
                            @click="getView(item)">
                            <v-list-item-avatar>
                                <v-icon class="secondary" dark>mdi-{{ item.icon }}</v-icon>
                            </v-list-item-avatar>

                            <v-list-item-content>
                                <v-list-item-title v-text="item.title"></v-list-item-title>
                                <v-list-item-subtitle v-text="item.content"></v-list-item-subtitle>
                            </v-list-item-content>

                            <v-list-item-action>
                                <v-list-item-action-text v-text="timeFormat(item.created_at)"></v-list-item-action-text>
                                <v-icon v-if="item.status === 0" color="secondary">mdi-circle-medium</v-icon>
                                <v-icon v-else color="success">mdi-check-all</v-icon>
                            </v-list-item-action>
                        </v-list-item>

                        <v-divider v-if="index < notificationItems.length - 1" :key="'D' + index"></v-divider>
                    </template>
                </v-list>
            </v-col>
            <v-dialog v-model="view" max-width="300">
                <v-card>
                    <v-card-title class="text-h6">{{ item.title }}</v-card-title>
                    <v-card-text>{{ item.content }}</v-card-text>
                    <v-card-actions>
                        <v-btn color="error" text @click="closeView">Cerrar</v-btn>
                        <v-spacer></v-spacer>
                        <v-btn v-if="item.link" color="primary" text :to="'/' + item.link">Ver</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>
    </v-container>
</template>

<script>
    import axios from 'axios';

    export default {
        name: "Notifications",
        props: {
            user: Object,
            items: {
                type: Array,
                default: () => []
            }
        },
        data: () => ({
            loading: true,
            view: false,
            item: {},
            localItems: []
        }),
        computed: {
            notificationItems() {
                return this.items && this.items.length > 0 ? this.items : this.localItems;
            }
        },
        watch: {
            items() {
                this.loading = false;
            }
        },
        mounted() {
            this.refresh();
        },
        methods: {
            timeFormat(v) {
                const now = new Date();
                const date = new Date(v);
                const diffMs = now - date;
                const diffMin = Math.floor(diffMs / 60000);
                const diffHr = Math.floor(diffMin / 60);

                if (diffMin < 1) {
                    return 'Ahora';
                } else if (diffMin < 60) {
                    return 'Hace ' + diffMin + ' min';
                } else if (diffHr < 24) {
                    return 'Hace ' + diffHr + ' horas';
                } else {
                    return v;
                }
            },
            refresh() {
                this.loading = true;
                axios.get('/api/notifications').then((res) => {
                    this.localItems = res.data.items || [];
                    this.$emit('notifications-updated', res.data);
                }).catch(() => {}).then(() => {
                    this.loading = false;
                });
            },
            getView(i) {
                this.item = i;
                this.view = true;

                if (i.status === 0) {
                    i.status = 1;
                    axios.post('/api/notifications', {id: i.id}).then((res) => {
                        this.localItems = res.data.items || this.localItems;
                        this.$emit('notifications-updated', res.data);
                    }).catch(() => {
                        i.status = 0;
                    });
                }
            },
            closeView() {
                this.view = false;
                this.item = {};
            }
        }
    }
</script>

<style scoped>

</style>
